import {
  Button,
  ButtonsWrapper,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AddBankCard } from './components/add-bank-card';
import { PaymentInfoView } from './components/payment-info-view';
import { HeaderContainer } from './payment-information.styles';
import { PaymentsListTable } from './components/payments-list-table';

const PaymentInformation = () => {
  const { t } = useTranslation(['settings', 'common']);
  const [isOpenedChangeCard, setIsOpenedChangeCard] = useState(false);
  const [isViewPaymentHistory, showPaymentHistory] = useState(false);

  const stripeResponse = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY);

  return (
    <div>
      {isOpenedChangeCard && (
        <Elements stripe={stripeResponse}>
          <AddBankCard onClose={() => setIsOpenedChangeCard(false)} />
        </Elements>
      )}
      <HeaderContainer isHistory={isViewPaymentHistory}>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t(
            `settings:paymentInformation.labels.${
              isViewPaymentHistory ? 'paymentHistory' : 'paymentInformation'
            }`
          )}
        </Typography>
        <ButtonsWrapper>
          <Button type="primary" ghost onClick={() => showPaymentHistory(!isViewPaymentHistory)}>
            {t(
              `settings:paymentInformation.buttons.${
                isViewPaymentHistory ? 'showPaymentInformation' : 'showPaymentHistory'
              }`
            )}
          </Button>
          {!isViewPaymentHistory && (
            <Button
              type="primary"
              ghost
              icon={ICONS.revision}
              iconColor={PLATFORM_THEME_COLORS.primary.blue}
              onClick={() => setIsOpenedChangeCard(true)}
            >
              {t('settings:userProfileSettings.labels.changeCard')}
            </Button>
          )}
        </ButtonsWrapper>
      </HeaderContainer>
      {isViewPaymentHistory ? <PaymentsListTable /> : <PaymentInfoView />}
    </div>
  );
};

export default PaymentInformation;
